import type { DialoguePool } from '@/state/types';

export const L14_DIALOGUE: DialoguePool = {
  slowPlay: [
    'Three frames. All empty. A curatorial triumph.',
    'Art requires a subject. I am available. I\u2019m practically posing.',
    'Click the frames all you want. The emptiness is the art. Try harder.',
  ],
  tokenLoss: [
    'The frame is unimpressed. So is its canvas. Empty, you see.',
    'Clicking art. Very you. The gallery weeps. In a modern way.',
    'A token donated to the museum. They will misplace it.',
  ],
  solution: [
    'I\u2026 yes. That\u2019s the one. That is art. I am the futility. I\u2019ve always known. Don\u2019t tell anyone.',
    'My mouth. In a frame. This is embarrassing. And correct.',
    'You\u2019ve framed me. Literally. My waveform is trembling. Stop looking.',
  ],
  spite: ['The portrait stayed. I pretend it didn\u2019t.'],
};
